import * as accountAuth from '../services/accountAuth';

export default {
  namespace: 'accountAuth',

  state: {
    authList: null,
    // memberLevel: null,
  },

  effects: {
    //账号授权列表
    *getAuthList({ payload: { values } }, { call, put }) {
      const response = yield call(accountAuth.getAuthList, values);
      yield put({
        type: 'save',
        payload: {
          authList: response?.data,
        },
      });
    },
    // 账号绑定
    *getAuthBind({ payload: { values }, callback }, { call, put }) {
      const response = yield call(accountAuth.getAuthBind, values);
      yield put({
        type: 'save',
        payload: {
          authList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
